import type { HttpGetBlob } from '@/shared/infra/http'
import { mapServerError } from '@/shared/infra/http'
import type { DownloadSignatureRequestCertificate } from '@/shared/domain'

export class SupabaseDownloadSignatureRequestCertificateRepository {
  constructor(private readonly http: HttpGetBlob) {}

  execute: DownloadSignatureRequestCertificate = async ({ id }) => {
    try {
      return await this.http.getBlob({
        url: `/signature-requests/${encodeURIComponent(id)}/certificate`,
      })
    } catch (error) {
      mapServerError(error)
    }
  }
}
